import {
  IconArrowUpRight,
  IconBell,
  IconCreditCardPay,
  IconFileTextShield,
  IconHeartHandshake,
  IconHomeHeart,
  IconMessages,
  IconPhone,
  IconPigMoney,
  IconShieldDollar,
  IconUsers
} from "@tabler/icons-react"
import { IFeature, IProduct, IQuality, ISubsidiary } from "./Pages/Home/Props"

export const gallery = ["/gallery/1.webp", "/gallery/2.webp", "/gallery/3.webp", "/gallery/5.webp"]

export const missionVision = [
  {
    image: "/mission/vision.webp",
    title: "Our Vision",
    content:
      "To innovate, inspire & build a transparent & user-friendly system with committed teamwork for exponential growth of our stakeholders."
  },
  {
    image: "/mission/mission.webp",
    title: "Our Mission",
    content:
      "To deliver the most admired, transparent, and customized financial solutions to build trust and sustainable growth."
  },
  {
    image: "/mission/values.webp",
    title: "Our Values",
    content: "- Transparency\n- Accountability\n- Innovation\n- Sustainability\n- Continuous Learning"
  },
  {
    image: "/gallery/11.webp",
    title: "Our Purpose",
    content: "- Empowerment\n- Excellence\n- Adaptability\n- Financial Inclusion\n- Compliance & Risk Management"
  }
]

export const features: IFeature[] = [
  {
    icon: IconUsers,
    title: "Grass-roots, Not just boardrooms",
    description: "We go to the villages, listen to real people, and solve real problems."
  },
  {
    icon: IconPigMoney,
    title: "Small Loans, Big Dreams",
    description: "From tea stalls to tailoring shops, we help people grow their dreams."
  },
  {
    icon: IconMessages,
    title: "Simple Words. Straight Talk.",
    description: "No hidden charges or jargon. Just honest, human communication."
  },
  {
    icon: IconHeartHandshake,
    title: "Not Just Finance — Full Support",
    description: "Loans are just the beginning. We offer hope and a helping hand."
  },
  {
    icon: IconHomeHeart,
    title: "Modern Ideas, Traditional Heart",
    description: "We combine innovation with values — from microfinance to smart housing."
  },
  {
    icon: IconArrowUpRight,
    title: "Together we grow, you & us.",
    description: "Every repaid loan and improved life is our real profit. Your success is our celebration."
  }
]

export const subsidaries: ISubsidiary[] = [
  {
    image: "/subsidary/jbr.webp",
    name: "J B Raval Micro Services Foundation",
    description:
      " Dedicated to providing urban and semi-urban microfinance services, promoting financial inclusion and growth."
  },
  {
    image: "/subsidary/jbr.webp",
    name: "Uttam Rural Micro Benefit Foundation",
    description: "Focusing on rural microfinance solutions to empower farming communities and rural entrepreneurs."
  },
  {
    image: "/subsidary/creations.webp",
    name: "Dharohar Creations Pvt Ltd",
    description: "Focusing on rural microfinance solutions to empower farming communities and rural entrepreneurs."
  }
]

export const qualities: IQuality[] = [
  { title: "Transparent Policies", icon: IconFileTextShield },
  { title: "Secure Transactions", icon: IconShieldDollar },
  { title: "24x7 Support", icon: IconPhone },
  { title: "Digital Payments", icon: IconCreditCardPay },
  { title: "Transaction Alerts", icon: IconBell }
]

export const products: IProduct[] = [
  {
    name: "Dharohar Pragati",
    description: "Ideal for meeting urgent and small-scale financial needs with ease and speed",
    amount: "Rs.5,000 to 1,00,000",
    term: "6 months",
    rate: "20% (Flat)",
    frequency: "Daily"
  },
  {
    name: "Dharohar Udyam",
    description: "Perfect for small business owners and those with weekly income cycles.",
    amount: "Rs.10,000 to 1,00,000",
    term: "6 months",
    rate: "20% (Flat)",
    frequency: "Weekly"
  },
  {
    name: "Dharohar Samarth",
    description: "Balances convenience and discipline in cash flow.",
    amount: "Rs.20,000 to 1,50,000",
    term: "6 months",
    rate: "20% (Flat)",
    frequency: "Bi-Weekly (Every 15 Days)"
  },
  {
    name: "Dharohar Samriddhi",
    description: "For planned financial needs and longer-term investments",
    amount: "Rs.20,000 to 1,50,000",
    term: "6 months",
    rate: "20% (Flat)",
    frequency: "Monthly"
  }
]

export const colors = [
  "blue",
  "green",
  "orange",
  "red",
  "violet",
  "yellow",
  "cyan",
  "pink",
  "indigo",
  "teal",
  "lime",
  "purple"
]
